import { render, staticRenderFns } from "./MarksListProfessorCell.vue?vue&type=template&id=db9e7eda"
import script from "./MarksListProfessorCell.vue?vue&type=script&lang=js"
export * from "./MarksListProfessorCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports